// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.env-indicator {
  font-size: 33px;
  color: red;
  text-align: center;
  z-index: 99;
  position: absolute;
  bottom: 0px;
  left: 49%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AACJ","sourcesContent":[".env-indicator{\n    font-size: 33px;\n    color: red;\n    text-align: center;\n    z-index: 99;\n    position: absolute;\n    bottom: 0px;\n    left: 49%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
